import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';


import { Nav, NavItem } from 'reactstrap';
import { CustomLogin, CustomRegister, CustomSearch } from '../components';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import AuthService from '../security/AuthService';
import CustomAuthLayer from '../components/CustomAuthLayer';



const ExhebitionTopNavigation = (props) => {
    console.log("ExhebitionTopNavigation props ", props);

    const { t } = useTranslation();

    const navigate = useNavigate();
    const opAuth = useRef(null);

    const [showLogin, setShowLogin] = useState(false);

    let { usermail, verificationToken, action } = useParams();

    const toast = useRef(null);
    const authLayer = () => {
        return (
            <OverlayPanel ref={opAuth}
                onHide={() => {
                    console.log("onHide", showLogin)
                    setShowLogin(false)
                }}
                style={{
                    boxShadow: '1px 2px 9px #4C4C4C',
                    maxWidth: 314,
                    borderRadius: 20,
                }}>
                <CustomAuthLayer op={opAuth} toast={toast} 
                />


            </OverlayPanel>

        )


    }
    const onAuthButtonClick = (e) => {
        if (AuthService.isLoggedIn()) {
            setShowLogin(true);

            opAuth.current.toggle(e);
        }
          
    };


    return (
        <div className='surface-header'>
            <Toast ref={toast} />

            <nav className="navbar navbar-expand-md navbar-light d-none d-lg-block sticky-top" role="navigation">

                <div className="container-fluid">
                    <a className="navbar-brand" href="/">
                        <img id="topbar-logo" src={`/assets/layout/images/logo-${props.themeColor === 'light' ? 'light' : 'dark'}.png`} alt="vault-layout" className="logo" />

                    </a>

                    <Nav className="ml-auto">
                        <NavItem>
                            <Button icon="fas fa-user-large" className={ showLogin ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-header mr-2 mb-2"}
                                onClick={(e) => onAuthButtonClick(e)} >

                            </Button>
                            {authLayer()}
                        </NavItem>
                    </Nav>
                </div>
            </nav>


        </div>
    );
};

export default ExhebitionTopNavigation;
